import { splitNameParts } from '../utils/string';

export function validateFullName(
  fullname?: string,
  required: boolean = true,
  firstNameRequired: boolean = true,
  lastNameRequired: boolean = true
): string | undefined {
  if (!fullname) {
    return required ? `Name is required` : undefined;
  }

  const parts = splitNameParts(fullname);

  if (firstNameRequired && !parts.first) {
    return `First name is required`;
  }

  if (lastNameRequired && !parts.last) {
    return `Last name is required`;
  }

  return undefined;
}



// WEBPACK FOOTER //
// ./src/app/validators/name.ts